import React from "react";
import { Chip } from "@mui/material";
import {
    historyEventToLastChange,
    isSpecialLastChange,
    lastChangeLabel,
} from "../../utils/loyaltyQualification";

const TONE = {
    upgrade: { bgcolor: "#dcfce7", color: "#166534" },
    downgrade: { bgcolor: "#fee2e2", color: "#991b1b" },
    no_change: { bgcolor: "#e0f2fe", color: "#075985" },
    admin_override: { bgcolor: "#ede9fe", color: "#5b21b6" },
    mode_changed: { bgcolor: "#fef3c7", color: "#92400e" },
    first_purchase_bypass: { bgcolor: "#ffedd5", color: "#9a3412" },
};

export default function LastChangeChip({ value, size = "small" }) {
    const key = historyEventToLastChange({ lastChange: value }) || String(value || "");
    const label = lastChangeLabel(key);
    if (!label) return null;
    const tone = TONE[key] || { bgcolor: "#f1f5f9", color: "#334155" };
    return (
        <Chip
            size={size}
            label={label}
            sx={{
                fontWeight: 700,
                fontSize: 11,
                borderRadius: 1.5,
                ...tone,
                border: isSpecialLastChange(key) ? "1px solid currentColor" : "none",
            }}
        />
    );
}
